const newsSideToggle = () => {
  const sideTitle = document.querySelectorAll('.news-details__side-title')

  for(let item of sideTitle) {
    item.addEventListener("click", function(){
      if(screen.width <= 767) {
        const sibling = this.nextElementSibling;
        if(sibling.classList.contains('active')) {
          sibling.classList.remove('active');
        } else {
          sibling.classList.add('active');
        }
      }
    });
  }
}

export default  newsSideToggle